// extracted by mini-css-extract-plugin
export default {"message":"FeedItemList-message","container":"FeedItemList-container","loadmore":"FeedItemList-loadmore","carousel":"FeedItemList-carousel","carouselItem":"FeedItemList-carouselItem"};